<template>
	<div></div>
</template>

<script>
	import {SERVER_ADDR} from '@/config.js'

	export default {
		props: {
			callback: String
		},

		mounted() {
			if (this.callback) {
				this.mp.reLaunch('/pages/home/index');
			} else {
				location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxb948e28fbab32a0e&redirect_uri=${location.origin}${SERVER_ADDR}/wechat/callback?session=${this.$store.state.session}&response_type=code&scope=snsapi_base&state=${location.origin}/bind?callback=1#wechat_redirect`;
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>